// extracted by mini-css-extract-plugin
export default {"canvas":"MazeCanvas_canvas__s6F3Z"};